<template>
  <div id="publication">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: 'publication'
}
</script>


// WEBPACK FOOTER //
// src/views/publication/Publication.vue